// Libraries
import { channel } from 'redux-saga'
import { get, has, defaultTo } from 'lodash'
import { put, take } from 'redux-saga/effects'

// Actions
// Resources
import { actions as scenarioActions } from 'Resources/ScenarioResource'

// Channels
const notificationChannel = channel()

export function* handleMessage(action) {
  if (has(action, 'content')) {
    try {
      yield put(
        scenarioActions.setComputedScenario(
          JSON.parse(defaultTo(get(action, 'content'), '').replace(/'/g, '"'))
        )
      )
    } catch (e) {
      // statements
      console.log(e)
    }
  }
}

export function connected(action) {}

export function* disconnected(action) {}

export function* watchNotificationChannel() {
  while (true) {
    const action = yield take(notificationChannel)
    yield put(action)
  }
}
